import Joyride from "react-joyride";
import { useEffect, useState } from "react";
import { useTutorial } from "../../hooks/useTutorial";
import { useNavigate } from "react-router-dom";
import { tutorialFlowMap } from "./tutorialSteps";
import { tutorialSeriesMap } from "./tutorialSeriesMap";

const TutorialController = () => {
  const {
    steps,
    isActive,
    currentStepIndex,
    saveTourProgress,
    saveTutorialProgress,
    stopTutorial,
    saveProgress,
    startTutorial,
  } = useTutorial();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [type, setType] = useState(null);
  const mapArray = Object.keys(tutorialSeriesMap);

  useEffect(() => {
    // console.log("tutorialSeriesMap", tutorialSeriesMap);
    if (!isActive) {
      setReady(false);
      return;
    }

    const saved = localStorage.getItem("tutorialProgress");
    if (saved) {
      const { path, stepIndex, type } = JSON.parse(saved);
      // console.log("saved type", type);
      setType(type);
    }

    const checkTargetExists = () => {
      // console.log("steps", steps);
      const stepsTargetsExist = steps.every((step) => !!document.querySelector(step.target));
      // console.log("stepsTargetsExist", stepsTargetsExist);
      // console.log("document.querySelector", document.querySelector(steps[0].target));
      if (stepsTargetsExist) {
        console.log("모든 타겟 요소가 존재합니다.");
        setReady(true);
      } else {
        setReady(false);
        // console.log("재검사");
        setTimeout(checkTargetExists, 200);
      }
    };

    checkTargetExists();
  }, [isActive, steps]);

  const handleCallback = (data: any) => {
    const { status, index, action, type } = data;
    const stored = JSON.parse(localStorage.getItem("tutorialProgress") || "{}");

    if (type === "step:after" && action === "next") {
      // console.log("saveTourProgress", index + 1, stored.series);
      // saveTourProgress(index + 1);
      saveProgress(index + 1, stored.series);
    }
    // 사용자가 중단한 경우
    if (action === "close") {
      // console.log("튜토리얼 중단");
      stopTutorial();
      return;
    }
    if (["finished", "skipped"].includes(status)) {
      // console.log("튜토리얼 종료");
      stopTutorial();
      const currentPath = window.location.pathname;
      const currentSeries = stored.series;
      // console.log("currentSeries", currentSeries);
      const currentFlow = tutorialSeriesMap[currentSeries]?.flow;
      const nextPath = currentFlow?.[currentPath];
      // console.log("currentFlow", currentFlow);
      // console.log("nextPath", nextPath);
      // const currentPath = window.location.pathname;
      // const nextPath = tutorialFlowMap[currentPath];
      if (nextPath) {
        // console.log("nextPath", nextPath);
        localStorage.setItem(
          "tutorialProgress",
          JSON.stringify({
            path: nextPath,
            stepIndex: 0,
            series: currentSeries,
          }),
        );
        // saveProgress(0, currentSeries);

        setTimeout(() => {
          navigate(nextPath);
        }, 100);
      } else {
        const nextSeries = getNextSeries(currentSeries);
        // console.log("nextSeries", nextSeries);
        if (nextSeries && tutorialSeriesMap[nextSeries]) {
          const firstPath = Object.keys(tutorialSeriesMap[nextSeries].flow)[0];
          // console.log("firstPath", firstPath);
          // localStorage.setItem(
          //   "tutorialProgress",
          //   JSON.stringify({
          //     path: firstPath,
          //     stepIndex: 0,
          //     type: "tutorial",
          //     series: "test",
          //   })
          // );
          // saveTutorialProgress(0);
          saveProgress(0, nextSeries);
          startTutorial(firstPath, 0, nextSeries);
          // console.log(`다음 튜토리얼 시리즈(${nextSeries})로 이동`);
          setTimeout(() => {
            navigate(firstPath);
          }, 100);
        } else {
          console.log("모든 튜토리얼 시리즈 완료 🎉");
        }
      }
    }
  };

  const getNextSeries = (current: string): string | null => {
    const idx = mapArray.indexOf(current);
    // console.log("mapArray", mapArray);
    // console.log("current", current);
    // console.log("getNextSeries idx", idx);
    if (idx >= 0 && idx + 1 < mapArray.length) {
      return mapArray[idx + 1];
    }
    return null;
  };
  return (
    <Joyride
      steps={steps}
      // run={isActive}
      run={isActive && ready}
      stepIndex={currentStepIndex}
      continuous
      showProgress
      showSkipButton
      disableOverlayClose
      spotlightClicks={false}
      disableOverlay={false}
      callback={handleCallback}
      styles={{
        options: {
          zIndex: 10000,
          // arrowColor: "#fff",
          // backgroundColor: "var(--dk-surface, #fff)",
          // primaryColor: "#000",
          // textColor: "#333",
          spotlightPadding: 0,
        } as any,
        tooltipContent: {
          whiteSpace: "pre-line",
        },
      }}
    />
  );
};

export default TutorialController;
